import { passwordRegex } from 'constants/regex';
import { t } from 'i18next';
import * as Yup from 'yup';

export const enterPasswordValidationSchema = Yup.object({
  password: Yup.string().required(() => t('required')).matches(passwordRegex, () => t('passwordError')),
});
